import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { AthleteEventSendAttendance, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useSendAthleteAttendance(): UseMutationResult<
  AxiosResponse<AthleteEventSendAttendance>,
  AxiosError<ErrorMessage>,
  AthleteEventSendAttendance
> {
  const mutationFn = (
    payload: AthleteEventSendAttendance,
  ): Promise<AxiosResponse<AthleteEventSendAttendance>> => {
    return client.post(`athlete-events/send-attendance/`, payload);
  };

  return useMutation(mutationFn);
}
